var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1408 12.5501C52.9698 11.2366 49.4804 10.893 46.1141 11.5626C42.7477 12.2322 39.6555 13.885 37.2284 16.3121C34.8014 18.7391 33.1486 21.8313 32.479 25.1977C31.8094 28.5641 32.153 32.0534 33.4665 35.2245C34.78 38.3955 37.0043 41.1059 39.8582 43.0128C42.7121 44.9197 46.0674 45.9375 49.4997 45.9375C54.1023 45.9375 58.5164 44.1091 61.7709 40.8546C65.0255 37.6 66.8539 33.1859 66.8539 28.5833C66.8539 25.151 65.836 21.7957 63.9291 18.9418C62.0222 16.088 59.3119 13.8636 56.1408 12.5501ZM44.9191 5.55528C49.4736 4.64933 54.1945 5.1143 58.4848 6.89138C62.775 8.66846 66.442 11.6778 69.0219 15.539C71.6018 19.4001 72.9789 23.9396 72.9789 28.5833C72.9789 34.8104 70.5052 40.7824 66.102 45.1856C61.6988 49.5888 55.7267 52.0625 49.4997 52.0625C44.8559 52.0625 40.3165 50.6854 36.4554 48.1055C32.5942 45.5256 29.5848 41.8587 27.8078 37.5684C26.0307 33.2781 25.5657 28.5573 26.4717 24.0027C27.3776 19.4482 29.6138 15.2646 32.8974 11.981C36.181 8.6974 40.3646 6.46123 44.9191 5.55528Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3613 89.8333C11.3613 71.7815 29.0713 58.1875 49.4997 58.1875C69.9281 58.1875 87.638 71.7815 87.638 89.8333C87.638 91.5247 86.2669 92.8958 84.5755 92.8958C82.8841 92.8958 81.513 91.5247 81.513 89.8333C81.513 76.2802 67.7813 64.3125 49.4997 64.3125C31.2181 64.3125 17.4863 76.2802 17.4863 89.8333C17.4863 91.5247 16.1152 92.8958 14.4238 92.8958C12.7325 92.8958 11.3613 91.5247 11.3613 89.8333Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcono);
export default __webpack_public_path__ + "static/media/user-icono.a0b01d6aa532b73beb9f75f703e6ce2c.svg";
export { ForwardRef as ReactComponent };